import { render } from "./Faqs.vue.ts?vue&type=template&id=497be7d7&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Faqs.vue?vue&type=template&id=497be7d7&scoped=true&ts=true"
import script from "./Faqs.vue.ts?vue&type=script&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Faqs.vue?vue&type=script&lang=ts"
export * from "./Faqs.vue.ts?vue&type=script&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Faqs.vue?vue&type=script&lang=ts"

import "./Faqs.vue.scss?vue&type=style&index=0&id=497be7d7&lang=scss&scoped=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Faqs.vue?vue&type=style&index=0&id=497be7d7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497be7d7"],['__file',"src/apps/credit-line/components/Help/Faqs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "497be7d7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('497be7d7', __exports__)) {
    api.reload('497be7d7', __exports__)
  }
  
  module.hot.accept("./Faqs.vue.ts?vue&type=template&id=497be7d7&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Faqs.vue?vue&type=template&id=497be7d7&scoped=true&ts=true", () => {
    api.rerender('497be7d7', render)
  })

}


export default __exports__